'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _raLanguageEnglish = require('ra-language-english');

var _raLanguageEnglish2 = _interopRequireDefault(_raLanguageEnglish);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _raLanguageEnglish2.default;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/lib/i18n/defaultI18nProvider.js
// module id = 1159
// module chunks = 0